import { Injectable } from "@angular/core";
import { AttachmentTypeCreator, IAttachmentType } from "@ramudden/models/attachment";
import { ExistsResult, ExistsValue } from "@ramudden/models/search";
import { Observable } from "rxjs";
import { ApiService } from "./api";

@Injectable({
    providedIn: "root",
})
export class AttachmentTypeApi extends ApiService<IAttachmentType, AttachmentTypeCreator, AttachmentTypeCreator> {
    override getRoute(): string {
        return "AttachmentTypes";
    }

    exists$(existsValue: ExistsValue): Observable<ExistsResult> {
        const url = `${super.getUrl()}/Exists`;
        return this.http.get<ExistsResult>(url, { params: { code: existsValue.value } });
    }
}
